<div class="permissions-page" [attr.dir]="dir">

  <!-- Hero -->
  <header class="page-hero">
    <div class="page-hero__text">
      <h1 class="page-hero__title">{{ 'ProjectEditPermissions' | navTitle | async }}</h1>
      <p class="page-hero__subtitle">
        {{ dir === 'rtl'
          ? 'تحكم في من يُسمح له بتعديل المشاريع من قائمة المستخدمين.'
          : 'Control who is allowed to edit projects from the users list.' }}
      </p>
    </div>
  </header>

  <!-- Stats -->
  <section class="stats-grid" aria-label="summary">
    <div class="stat-chip">
      <span class="stat-chip__value">{{ paginator?.total_records || users.length || 0 }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'المستخدمون' : 'Users' }}</span>
    </div>
    <div class="stat-chip allowed">
      <span class="stat-chip__value">{{ getAllowedCount() }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'مسموح' : 'Allowed' }}</span>
    </div>
    <div class="stat-chip blocked">
      <span class="stat-chip__value">{{ getBlockedCount() }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'محظور' : 'Blocked' }}</span>
    </div>
    <div class="stat-chip">
      <span class="stat-chip__value">{{ filteredUsers.length }}</span>
      <span class="stat-chip__label">{{ dir === 'rtl' ? 'في الصفحة' : 'On page' }}</span>
    </div>
  </section>

  <!-- Toolbar -->
  <section class="toolbar-card">
    <div class="search-wrapper">
      <i class="fa-solid fa-magnifying-glass search-icon"></i>
      <input
        type="search"
        class="search-input"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        [placeholder]="dir === 'rtl' ? 'ابحث بالاسم أو اسم المستخدم أو البريد...' : 'Search by name, username or email...'" />
      @if (searchTerm) {
        <button type="button" class="search-clear" (click)="clearSearch()" [attr.aria-label]="dir === 'rtl' ? 'مسح' : 'Clear'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>
  </section>

  <!-- Table -->
  <section class="table-card">
    <div class="table-header">
      <h2 class="table-title">
        {{ dir === 'rtl' ? 'قائمة المستخدمين' : 'Users list' }}
      </h2>
      <span class="table-hint">
        {{ dir === 'rtl' ? 'بدّل الحالة مباشرة من العمود الأخير' : 'Toggle status directly from the last column' }}
      </span>
    </div>

    @if (isLoading) {
      <div class="loading-state">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>{{ dir === 'rtl' ? 'جاري التحميل...' : 'Loading...' }}</span>
      </div>
    } @else {
      <div class="table-wrapper">
        <p-table [value]="filteredUsers" [paginator]="false" styleClass="permissions-table">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ dir === 'rtl' ? 'الاسم' : 'Name' }}</th>
              <th>{{ dir === 'rtl' ? 'اسم المستخدم' : 'Username' }}</th>
              <th>{{ dir === 'rtl' ? 'البريد الإلكتروني' : 'Email' }}</th>
              <th>{{ dir === 'rtl' ? 'الدور' : 'Role' }}</th>
              <th>{{ dir === 'rtl' ? 'صلاحية التعديل' : 'Edit Permission' }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-user>
            <tr [class.is-blocked]="!user.can_edit_projects">
              <td>
                <div class="user-cell">
                  <span class="user-avatar">{{ getInitials(user.name || user.username) }}</span>
                  <span class="user-name">{{ user.name }}</span>
                </div>
              </td>
              <td>
                <span class="mono">{{ user.username }}</span>
              </td>
              <td>
                <span class="muted-text">{{ user.email }}</span>
              </td>
              <td>
                <span class="role-pill">{{ user.role_name || user.role }}</span>
              </td>
              <td>
                <p-toggleButton
                  [ngModel]="user.can_edit_projects"
                  (ngModelChange)="toggleEditPermission(user, $event)"
                  [onLabel]="dir === 'rtl' ? 'مسموح' : 'Allowed'"
                  [offLabel]="dir === 'rtl' ? 'محظور' : 'Blocked'"
                  onIcon="pi pi-check"
                  offIcon="pi pi-times"
                  styleClass="perm-toggle">
                </p-toggleButton>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="5">
                <div class="empty-state">
                  <div class="empty-state__icon"><i class="fa-solid fa-users-slash"></i></div>
                  <p class="empty-state__title">
                    {{ dir === 'rtl' ? 'لا يوجد مستخدمون مطابقون' : 'No matching users' }}
                  </p>
                  <p class="empty-state__text">
                    {{ dir === 'rtl' ? 'جرّب كلمة بحث أخرى أو امسح البحث.' : 'Try another keyword or clear the search.' }}
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    @if (paginator && paginator.total_records > 0) {
      <div class="paginator-wrap">
        <app-paginator
          [currentPage]="pageNumber"
          [totalItems]="paginator.total_records"
          [pageSize]="page_size"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)">
        </app-paginator>
      </div>
    }
  </section>
</div>
